import './onLoad';
import './aos-init';